import React from 'react';
import { useGetAllLandingQuery } from '../../store/api/userApiSlice';
import { IoArrowForward } from 'react-icons/io5';
import './NewsUpdates.css';
import collegePlaceholder from '../../assets/images/ftrdClgImgPlaceholder.png';

const NewsUpdates = () => {
  // Use userApiSlice's getAllLanding query which contains the blog data
  const { data, isLoading, error } = useGetAllLandingQuery();
  
  // Extract blog posts using the same logic as BlogPage.jsx
  let newsItems = [];
  if (data && Array.isArray(data) && data.length > 0 && Array.isArray(data[0].blog)) {
    newsItems = data[0].blog;
  } else if (Array.isArray(data)) {
    newsItems = data;
  }

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 0) {
      const diffHours = Math.floor(diffTime / (1000 * 60 * 60));
      if (diffHours === 0) {
        const diffMins = Math.floor(diffTime / (1000 * 60));
        return `${diffMins} min ago`;
      }
      return `${diffHours} hours ago`;
    } else if (diffDays === 1) {
      return 'Yesterday';
    } else if (diffDays < 7) {
      return `${diffDays} days ago`;
    }
    
    return date.toLocaleDateString('en-IN', { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric' 
    });
  };

  if (isLoading) {
    return (
      <div className="news-updates-wrapper">
        <section className="news-updates-section">
          <div className="news-header">
            <h2 className="news-heading">Latest exams News & Updates</h2>
          </div>
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <p>Loading updates...</p>
          </div>
        </section>
      </div>
    );
  }

  if (error) {
    return (
        <div className="news-updates-wrapper">
        <section className="news-updates-section">
          <div className="news-header">
            <h2 className="news-heading">Latest exams News & Updates</h2>
          </div>
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <p>Unable to load updates.</p>
          </div>
        </section>
      </div>
    )
  }

  return (
    <div className="news-updates-wrapper">
      <section className="news-updates-section">
        <div className="news-header">
          <h2 className="news-heading">Latest exams News & Updates</h2>
          <a href="/blogs" className="view-all-link">
            VIEW ALL <IoArrowForward />
          </a>
        </div>
        
        <div className="news-list">
          {newsItems.slice(0, 4).map((item) => (
            <div key={item._id || item.id} className="news-item">
              <div className="news-content">
                <h3 className="news-title">{item.title}</h3>
                <p className="news-description">{item.description || item.excerpt || item.content?.substring(0, 100) + '...'}</p>
                <span className="news-meta">{formatDate(item.createdAt || item.date)}</span>
              </div>
              <div className="news-image-wrapper">
                <img src={item.image || collegePlaceholder} alt={item.title} className="news-image" onError={(e) => {e.target.src = collegePlaceholder}} />
              </div>
            </div>
          ))}
          {newsItems.length === 0 && (
              <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
                  No updates available at the moment.
              </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default NewsUpdates;
